module.exports = __webpack_public_path__ + "img/2.6e254d5b.png";